import './Process.scss'
import React, { useEffect, useRef, useState } from 'react'

const steps = [
    {
        title: 'Diagnostic',
        text: 'On regarde ensemble l’existant : votre site, vos outils, votre organisation, ce qui fonctionne et ce qui vous fait perdre du temps.',
    },
    {
        title: 'Architecture',
        text: 'Je propose les choix structurants : ce qu’il faut garder, connecter ou refaire — et ce que vous pouvez piloter vous-même avec l’IA.',
    },
    {
        title: 'Exécution ciblée',
        text: 'J’interviens en développement sur les points qui demandent une expertise pointue : intégrations, UX/UI, back-office sur mesure.',
    },
    {
        title: 'Mise en ligne',
        text: 'Je m’occupe du déploiement, des tests, des réglages techniques et de l’optimisation.',
    },
    {
        title: 'Autonomie & suivi',
        text: 'Je vous transmets ce qui peut être piloté en interne, et je reste disponible pour faire évoluer le projet dans le temps.',
    },
]

// from / to: slice of steps shown (a panel can show only part of the process)
function Process({ from = 0, to = steps.length, headerMode = 'full' }) {
    const listRef = useRef(null)
    const [isVisible, setIsVisible] = useState(false)
    const isFull = headerMode === 'full'

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting)
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '0px 0px -50px 0px'
            }
        )

        const list = listRef.current

        if (list) {
            observer.observe(list)
        }

        return () => {
            if (list) {
                observer.unobserve(list)
            }
        }
    }, [])

    return (
        <section
            className="process"
            aria-labelledby={isFull ? 'process-title' : undefined}
            aria-label={isFull ? undefined : 'Collaboration, étape par étape'}
        >
            <div className="process__container">
                {isFull ? (
                    <div className="process__container__header">
                        <h2 id="process-title" className="process__title">
                            Collaboration
                        </h2>

                        <p className="process__subtitle">
                            étape par étape
                        </p>
                    </div>
                ) : (
                    <p className="sectionEyebrow">Collaboration — étape par étape</p>
                )}

                <ol
                    ref={listRef}
                    start={from + 1}
                    className={`process__list process__list--${to - from} ${isVisible ? 'visible' : ''}`}
                    aria-label="Les différentes étapes de la collaboration"
                >
                    {steps.slice(from, to).map((step, i) => {
                        const n = from + i + 1

                        return (
                            <li key={step.title} className={`process__item process__item--${n}`}>
                                <span className="process__item-number" aria-hidden="true">
                                    {String(n).padStart(2, '0')}
                                </span>
                                <div className="process__item-infos">
                                    <h3 className="process__item-title">{step.title}</h3>
                                    <p className="process__item-text">{step.text}</p>
                                </div>
                            </li>
                        )
                    })}
                </ol>
            </div>
        </section>
    )
}

export default Process
